module.exports = __webpack_public_path__ + "static/02d47d48d9d086c9c6b601606b6f12bfe9ee19d37d40e6e334b15fbe5df00be9-fea2a54d861c517709d511e9776ce960.jpeg";